import { Component, Host, h, State, Listen, Element, Watch, Event, EventEmitter } from '@stencil/core';
import { isPlatform } from '@baloise/ds-core';

@Component({
  tag: 'bam-tab-component',
  styleUrl: 'bam-tab-component.scss',
})
export class BamTabComponent {
  @Element() el: HTMLElement;
  @State() tabSelected: string;
  @State() isMobile: boolean = false;
  @State() hasTab: boolean = false;
  @State() hashID: string = undefined;

  private itemElements: NodeListOf<HTMLBalTabItemElement>;
  private tabsElements;
  @Event() pauseYoutube: EventEmitter;

  @Listen('balChange')
  onBalChange(event: CustomEvent<string>) {
    this.tabSelected = event.detail;
    this.showActiveSelectItems(this.tabSelected);
  }

  @Listen('hashchange', { target: 'window' })
  async onhashChange() {
    if (window.location.hash !== '') {
      this.checkHash();
      this.setActiveItem();

      if (this.hasTab) {
        this.el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  @Listen('resize', { target: 'window' })
  handleResize() {
    this.isMobile = isPlatform('mobile');
  }

  @Watch('isMobile')
  watchViewPortHandler(newValue: boolean) {
    if (newValue === false) {
      this.setAnchors();
    }
  }

  setAnchors = () => {
    // used timeout to make sure list elements in tabs are actually present
    // deepReady provided from the DS did not work for that purpose
    // open for refactoring in the future
    return new Promise(resolve => {
      setTimeout(() => {
        this.tabsElements = this.el.querySelectorAll('bal-tabs nav .bal-tabs__nav__item');
        this.itemElements.forEach(el => el.removeAttribute('id'));
        this.tabsElements.forEach(el => {
          el.id = el.getAttribute('data-value')?.replace('tab-', 'id-');
        });
        resolve(true);
      }, 50);
    });
  };

  pauseYTVideos() {
    this.pauseYoutube.emit();
  }

  setActiveItem = () => {
    const tabId = `tab-${this.hashID}`;

    this.tabSelected = this.hashID;

    if (this.hasTab) {
      this.el.querySelector('bal-tabs').setAttribute('value', tabId);
      this.showActiveSelectItems(tabId);
    } else {
      const initialTab = this.el.querySelector('bal-tabs');
      this.tabSelected = initialTab.value;
      this.showActiveSelectItems(initialTab.value);
    }
  };

  showActiveSelectItems(tabId: string) {
    this.itemElements.forEach(itemEl => {
      if (itemEl.classList.contains('is-active')) this.pauseYTVideos();
      itemEl.classList.toggle('is-active', itemEl.value == tabId);
    });
  }

  checkHash = () => {
    this.hashID = window.location.hash.replace('#id-', '');
    this.hasTab = Array.from(this.itemElements).some(item => item.value.includes(this.hashID));
  };

  connectedCallback() {
    this.itemElements = this.el.querySelectorAll('bal-tab-item');
  }

  componentWillLoad() {
    this.isMobile = isPlatform('mobile');

    if (window.location.hash === '') {
      const initialTab = this.el.querySelector('bal-tabs');
      this.tabSelected = initialTab.value;
      this.showActiveSelectItems(initialTab.value);
    }
  }

  async componentDidLoad() {
    await this.setAnchors();

    if (window.location.hash !== '') {
      this.checkHash();
      this.setActiveItem();

      if (this.hasTab) {
        this.el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
